import classNames from 'classnames';
import { useEffect, useMemo, useRef, useState } from 'react';
import { MessagePlugin, Select, SelectValue } from 'tdesign-react';

import { RemoveFore, SpineIcon } from '@/components/icon';
import { ActionType, ChangeMediaOperationType, ChangeMediaType, EventType } from '@/const/mission';
import { IEvents } from '@/interface';
import { ISpineResult, IUploadSpineRef } from '@/material/form-upload/folder';
import UploadSpine from '@/material/form-upload/spine';

import styles from '../index.module.less';

interface IProps {
  contentEventIdColWidth: number | undefined;
  value: IEvents;
  disabled: boolean;
  onChange: (value: any) => void;
}

const SpineItem: React.FC<IProps> = (props) => {
  const { value, onChange, disabled } = props;

  const uploadSpineRef = useRef<IUploadSpineRef>(null);

  const handleChange = (data: ISpineResult) => {
    if (disabled) return;
    const postData: IEvents = {
      type: EventType.EVENT_TYPE_ACTION,
      action: {
        type: ActionType.ACTION_TYPE_CHANGEMEDIA,
        changeMedia: {
          ...value?.action?.changeMedia,
          type:
            value?.action?.changeMedia?.type
            || ChangeMediaType.CHANGE_MEDIA_TYPE_SPINE_FORE_IMAGE,
          spine: data,
        },
      },
    };
    onChange(postData);
  };

  const handleChangeSelect = (data: SelectValue) => {
    if (disabled) return;

    if (uploadSpineRef?.current?.loading === true) {
      MessagePlugin.warning('请等待上传完成后再切换类型');
      return;
    }

    let operation = ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY;
    if (data === ChangeMediaType.REMOVE_FORE_IMAGE) {
      operation = ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE;
    } else {
      operation = ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY;
    }

    const postData: IEvents = {
      type: EventType.EVENT_TYPE_ACTION,
      action: {
        type: ActionType.ACTION_TYPE_CHANGEMEDIA,

        changeMedia: {
          ...value?.action?.changeMedia,
          type:
            value?.action?.changeMedia?.type
            || ChangeMediaType.CHANGE_MEDIA_TYPE_SPINE_FORE_IMAGE,
          operation,
        },
      },
    };
    onChange(postData);
  };

  const operation = value?.action?.changeMedia?.operation;
  const isRemove = operation === ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE;

  const getSelValue = () => (isRemove ? ChangeMediaType.REMOVE_FORE_IMAGE : value?.action?.changeMedia?.type);

  const [selectValue, setSelectValue] = useState(getSelValue());

  useEffect(() => {
    setSelectValue(getSelValue());
  }, [value]);

  const getOption = () => [
    { label: 'Spine 立绘', value: ChangeMediaType.CHANGE_MEDIA_TYPE_SPINE_FORE_IMAGE },
    { label: '移除立绘', value: ChangeMediaType.REMOVE_FORE_IMAGE },
  ];

  const options = useMemo(() => getOption(), []);

  return (
    <div className={styles.itemBox}>
      <div className={classNames(styles.system, styles.leftType, styles.noPadding, 'draggable')}>
        <Select
          prefixIcon={<div className={styles.selectPreIcon}>
            {selectValue === ChangeMediaType.REMOVE_FORE_IMAGE
              ? <RemoveFore />
              : <SpineIcon />}
          </div>}
          className={styles.botSelect}
          value={selectValue}
          onChange={handleChangeSelect}
          options={options}
          disabled={disabled}
          defaultValue={options?.[0]?.value}
        />
      </div>
      <div className={styles.contentBox}>
        {isRemove
          ? <div className={classNames(styles.pauseAudio, 'draggable', {
            ['nova-disabled-opacity']: disabled,
            ['nova-disabled']: disabled,
          })}>
            <span>移除立绘</span>
          </div>
          : <UploadSpine
            disabled={disabled}
            uploadSpineRef={uploadSpineRef}
            onChange={data => handleChange(data)}
            asyncUploadOnChange={data => handleChange(data as ISpineResult)}
            value={value?.action?.changeMedia?.spine || {}}
          />
        }
      </div>
    </div>
  );
};

export default SpineItem;
